// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/8fb03ba446f1b76a1d8a.bundle.js";
	if (chunkId === 3) return "static/js/4d6817aaca0af3c9ea06.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"00a36f6fbc76d35a9709","139":"70a50f3e73ea28e8912b","140":"c19423deb6be47b2bc2a"}[chunkId] + ".chunk.js";
};